


















import { Component, Vue } from 'vue-property-decorator';
import CardFormElement from '@/components/cards/CardFormElement.vue';
import Editor from '@/components/Editor.vue';
import ElementBase from './ElementBase';

@Component({
    name: 'ElementStaticText',
    components: {
        'editor': Editor,
        'card-form-element': CardFormElement,
    },
})
export default class ElementStaticText extends ElementBase {}
